<template>
  <v-footer tag="footer" color="#41281b" class="site-footer">
    <v-container>
      <v-row align="start" justify="space-between">
        <!-- Brand / logo -->
        <v-col cols="12" md="4" class="footer-brand">
          <router-link to="/" aria-label="ThinkSpatial home">
            <img :src="logo" alt="ThinkSpatial" class="footer-logo" loading="lazy" />
          </router-link>
          <p class="footer-tagline">Surveying, GIS, engineering and spatial technology.</p>
        </v-col>

        <!-- Contact details -->
        <v-col cols="12" md="4" class="footer-contact">
          <h2 class="footer-heading">Contact</h2>
          <address class="footer-address">
            <div>{{ contact.office }}</div>
            <div>
              <a :href="`tel:${contact.phoneHref}`">{{ contact.phone }}</a>
            </div>
            <div>
              <a :href="`mailto:${contact.email}`">{{ contact.email }}</a>
            </div>
          </address>
        </v-col>

        <!-- Legal links -->
        <v-col cols="12" md="4" class="footer-legal">
          <h2 class="footer-heading">Legal</h2>
          <ul class="footer-links">
            <li>
              <router-link to="/privacy-policy">Privacy Policy</router-link>
            </li>
            <li>
              <router-link to="/terms-and-conditions">Terms and Conditions</router-link>
            </li>
          </ul>
        </v-col>
      </v-row>

      <v-divider class="footer-divider" />

      <v-row justify="center">
        <div class="footer-copyright">
          &copy; {{ currentYear }} ThinkSpatial. All rights reserved.
        </div>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script setup>
import { computed } from 'vue';
import logo from 'assets/svg/ts-logo-white.svg';

// Contact details reused from the values in components/ContactUs.vue
// (office location) and the company enquiry address used by the server
// contact path. Centralised here so the footer renders on every page.
const contact = {
  office: 'Suite 4, 64 Sutton Street, North Melbourne, VIC 3051',
  // The Melbourne office number, matching contact.js `details.phone` and the
  // `melbourne` office entry. Previously a personal mobile.
  phone: '0416 018 826',
  phoneHref: '0416018826',
  email: 'projects@thinkspatial.com.au',
};

const currentYear = computed(() => new Date().getFullYear());
</script>

<style lang="scss" scoped>
.site-footer {
  color: #fff;
}

.footer-logo {
  height: 48px;
  width: auto;
  display: block;
}

.footer-tagline {
  margin-top: 12px;
  color: #d6cfca;
  font-size: 0.9rem;
}

.footer-heading {
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
}

.footer-address {
  font-style: normal;
  line-height: 1.8;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 2;
}

.site-footer a {
  color: #fff;
  text-decoration: none;
}

.site-footer a:hover,
.site-footer a:focus-visible {
  color: #f29400;
  text-decoration: underline;
}

.footer-divider {
  margin: 24px 0 16px;
  border-color: rgba(255, 255, 255, 0.2);
}

.footer-copyright {
  color: #d6cfca;
  font-size: 0.85rem;
}
</style>
